import { Component, OnInit,ViewChild } from '@angular/core';
import { MatDialog, MatPaginator,PageEvent, MatTableDataSource, MatSort, Sort, MatAutocompleteTrigger } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '../time.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-express-shipments-dashboard',
  templateUrl: './express-shipments-dashboard.component.html',
  styleUrls: ['./express-shipments-dashboard.component.scss']
})
export class ExpressShipmentsDashboardComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageEvent: PageEvent;

  showLoader = false;
  filter: any = "";
  selectedStatus: any; // holds the selected status (Available/Deleted)
  statusArray = [
    {
      status: "Active",
      is_deleted: false,
    },
    {
      status: "Deleted",
      is_deleted: true,
    },
  ];
  showAdvanceSearch = false;
  shipmentType = 'outbound';
  ordersArray: any = [];
  orders: any = [];
  totalOrders = 0;
  carrierId: Subscription;

  dashboardFilters: any = {   
    is_deleted: false, 
    trip_type: '',  
    limit: 0,
    skip: 0,
  };
  dataSource = new MatTableDataSource<Element>();

  //columnsToDisplay = ['sin', 'pickup_drop', 'date_time', 'vehicle_details', 'driver', 'distance', 'action'];
  columnsToDisplay = [ 'tripid', 'drop_location','booking_date','status','vehicle_type','ewaybill', 'action'];

  constructor(private dialog: MatDialog,private http: HttpService, 
    private snackBar: SnackbarService,
    private time: TimeService,
    private translation: TranslateService,
    ) { }

  ngOnInit() {
    this.selectedStatus = this.statusArray[0];
    this.getTrips();
  }

  
  getTrips(filters: any = {}) {
   
    this.showLoader = true;
    filters.limit = this.paginator.pageSize || 25;
    filters.trip_type= "PRIMARY"
    filters.skip =
      this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    filters.is_deleted = this.selectedStatus.is_deleted;
 
    if (this.filter) {
      filters.dashboard_filter = this.filter;
    }
    this.http.post("express_order/get_trips", filters).subscribe(
      (data: any) => {
        
        if (data.statusCode == 200) {
          this.ordersArray = data.data.trips;
          this.totalOrders = data.data.count;
          this.orders = [];

          this.ordersArray.forEach((element) => {

            const temp: any = {};
            temp._id = element._id;
            temp.shipment = element.TIN;
           // temp.drop_location=element.delivery_locations[0].loc_id.city;           
           // temp.client = element.organization.name;
           // let res=0;
           // element.commercial_invoice_details.filter(x=>res+=x.no_of_packages)
            //temp.packages =  res;
            //temp.booking_date = (element.created_at) ? this.formatTime(element.created_at) : '--';
            temp.status=element.status;
            temp.trip_type=element.trip_type
           

            this.orders.push(temp);
          });
          
          this.showLoader = false;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);
            //this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
          } else {
            this.dataSource = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant(
              "DASHBOARD.pagination_label"
            );
          }
        }
      },
      (err: any) => {
        
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        this.paginator._intl.itemsPerPageLabel = this.translation.instant(
          "DASHBOARD.pagination_label"
        );
        if (err.error.statusCode == 401) {
         // this.valid.logout();
        }
      }
    );
  }

  pageNavigate(event: PageEvent) {
    
    this.dashboardFilters.limit = event.pageSize;
    this.dashboardFilters.skip = event.pageIndex * event.pageSize;
    this.dashboardFilters.is_deleted = this.selectedStatus.is_deleted;
    this.getTrips(this.dashboardFilters);
  }
  formatTime(time) {
    return this.time.toShortDateTime(time, 'dd-MMM-yyyy');
  }
  
  toggle() {
    this.showAdvanceSearch = !this.showAdvanceSearch;
    // (this.showAdvanceSearch) ? this.getFilters() : '';
  }

  stopProp(){

  }
  sortShipmentData(e){

  }
}
